<template>
  <el-popover
    v-if="taskId"
    placement="top-start"
    effect="dark"
    popper-style="background: transparent; border: none; padding: 0;"
    width="auto"
  >
    <template #reference>
      <div
        class="w-8 h-8 flex items-center justify-center p-2 bg-black/80 text-white text-base font-bold rounded-lg cursor-pointer"
        @click="handleCopy"
      >
        ID
      </div>
    </template>
    <div class="flex items-center gap-1 bg-fill-3 text-text-1 p-2">
      <span>ID:</span>
      <span>{{ taskId }}</span>
      <Icon
        icon="sky:ic-copy"
        class="size-4 cursor-pointer"
        @click="handleCopy"
      />
    </div>
  </el-popover>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import copyText from '@/utils/copyText'

const { t } = useI18n()

type Props = {
  taskId?: string
}

const props = defineProps<Props>()

const handleCopy = () => {
  if (!props.taskId) return
  copyText(
    props.taskId,
    () => {
      ElMessage.success(t('common.id_copied_to_clipboard'))
    },
    () => {
      ElMessage.error(t('common.copy_failed'))
    },
  )
}
</script>
